import api from '../api'

export default {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        setStatePumList(state, info) {
            state.list = info
        }
    },
    getters: {
        getPump(state) {
            return state.list;
        }
    },
    actions: {
        getPumpingList(store,type) {
            return api.post(`/pumping/pumpinglist/${type}`, '指定的游戏抽水')
        },
        addPumping(store, {...params}) {
            return api.post(`/pumping/pumpingadd/`, '新增游戏抽水', params)
        },
        updatePumping(store, params) {
            return api.post(`/pumping/pumpingupdate/`, '修改游戏抽水', params)
        },
        deletePumping(store, id) {
            return api.post(`/pumping/pumpingdelete/${id}`, '删除游戏抽水')
        },


    }
}